import React, { useState } from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { ProblemSection } from '../components/sales/ProblemSection';
import { ProductSection } from '../components/sales/ProductSection';
import { ExamplesCarousel } from '../components/sales/ExamplesCarousel';
import { TestimonialsSection } from '../components/sales/TestimonialsSection';
import { MechanismSection } from '../components/sales/MechanismSection';
import { AudienceSection } from '../components/sales/AudienceSection';
import { PricingSection } from '../components/sales/PricingSection';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function SalesPage() {
  const [termsOpen, setTermsOpen] = useState(false);
  return <main className="min-h-screen w-full bg-[#050505] text-[#f0f0f0] font-sans selection:bg-[#00d4aa] selection:text-black" data-id="element-149">
      <HeroSection data-id="element-150" />
      <ProblemSection data-id="element-151" />
      <ProductSection data-id="element-152" />
      <ExamplesCarousel data-id="element-153" />
      <TestimonialsSection data-id="element-154" />
      <MechanismSection data-id="element-155" />
      <AudienceSection data-id="element-156" />
      <PricingSection data-id="element-157" />

      <footer className="py-12 text-center text-gray-600 text-sm bg-[#050505] border-t border-gray-900 space-y-6 px-6" data-id="element-158">
        <p data-id="element-159">
          © {new Date().getFullYear()} EBOOK CREATOR. Todos los derechos
          reservados.
        </p>
        <div className="max-w-2xl mx-auto" data-id="element-160">
          <button onClick={() => setTermsOpen(!termsOpen)} className="flex items-center justify-center gap-2 mx-auto text-gray-500 font-semibold uppercase tracking-wider text-[11px] hover:text-gray-400 transition-colors" data-id="element-161">
            <span data-id="element-162">Términos y Condiciones</span>
            <motion.div animate={{
            rotate: termsOpen ? 180 : 0
          }} transition={{
            duration: 0.3
          }} data-id="element-163">
              <ChevronDown className="w-4 h-4" data-id="element-164" />
            </motion.div>
          </button>

          <AnimatePresence data-id="element-165">
            {termsOpen && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3,
            ease: 'easeInOut'
          }} className="overflow-hidden" data-id="element-166">
                <div className="text-xs text-gray-700 space-y-4 leading-relaxed pt-6" data-id="element-167">
                  <p data-id="element-168">
                    Al adquirir EBOOK CREATOR, aceptas los siguientes términos:
                    Este producto es un recurso digital (GPT + videos) de acceso
                    inmediato. No se garantizan resultados específicos de
                    ventas, ya que estos dependen de la ejecución individual del
                    comprador.
                  </p>
                  <p data-id="element-169">
                    <strong className="text-gray-500" data-id="element-170">
                      Política de reembolso:
                    </strong>{' '}
                    Dispones de 7 días desde la fecha de compra para solicitar
                    un reembolso completo según nuestras políticas de
                    devolución, sin necesidad de justificación.
                  </p>
                  <p data-id="element-171">
                    <strong className="text-gray-500" data-id="element-172">
                      Propiedad intelectual:
                    </strong>{' '}
                    Todo el contenido incluido (prompts, videos, guías y
                    plantillas) es propiedad de Mauricio Medina. Queda prohibida
                    su redistribución, reventa o reproducción total o parcial
                    sin autorización expresa.
                  </p>
                  <p data-id="element-173">
                    <strong className="text-gray-500" data-id="element-174">Uso del producto:</strong>{' '}
                    La licencia es personal e intransferible. El acceso es
                    individual y no puede compartirse con terceros.
                  </p>
                  <p data-id="element-175">
                    <strong className="text-gray-500" data-id="element-176">Contacto:</strong> Para
                    consultas o soporte, comunícate por correo electrónico.
                  </p>
                  <p data-id="element-177">
                    Al completar tu compra, confirmas que has leído y aceptado
                    estos términos.
                  </p>
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>
      </footer>
    </main>;
}